import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyContactModal = ({ participant, profile, onClose }) => {
  const handleCall = () => {
    if (profile?.emergencyContactPhone) {
      window.open(`tel:${profile?.emergencyContactPhone}`);
    }
  };

  const handleSMS = () => {
    if (profile?.emergencyContactPhone) {
      window.open(`sms:${profile?.emergencyContactPhone}`);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-destructive/10 rounded-full flex items-center justify-center">
              <Icon name="Phone" size={20} className="text-destructive" />
            </div>
            <h2 className="font-heading text-xl font-semibold text-foreground">
              Emergency Contact
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm text-muted-foreground mb-1">Participant</p>
            <p className="text-base font-semibold text-foreground">{participant?.participantName}</p>
          </div>

          {profile?.emergencyContactName ? (
            <>
              <div className="bg-muted rounded-lg p-4">
                <p className="text-sm text-muted-foreground mb-1">Emergency Contact Name</p>
                <p className="text-base font-semibold text-foreground">{profile?.emergencyContactName}</p>
              </div>

              <div className="bg-muted rounded-lg p-4">
                <p className="text-sm text-muted-foreground mb-1">Emergency Contact Phone</p>
                <p className="text-base font-semibold text-foreground">{profile?.emergencyContactPhone}</p>
              </div>

              <div className="flex gap-3">
                <Button
                  variant="default"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={handleCall}
                  fullWidth
                >
                  Call
                </Button>
                <Button
                  variant="outline"
                  iconName="MessageSquare"
                  iconPosition="left"
                  onClick={handleSMS}
                  fullWidth
                >
                  SMS
                </Button>
              </div>

              <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
                <div className="flex items-start gap-2">
                  <Icon name="AlertTriangle" size={16} className="text-warning mt-0.5 flex-shrink-0" />
                  <p className="text-xs text-muted-foreground">
                    Only use this emergency contact in case of urgent situations or if the participant is unreachable.
                  </p>
                </div>
              </div>
            </>
          ) : (
            <div className="bg-muted rounded-lg p-4 text-center">
              <Icon name="AlertCircle" size={32} className="text-muted-foreground mx-auto mb-2" />
              <p className="text-sm text-muted-foreground">
                No emergency contact information available for this participant.
              </p>
            </div>
          )}
        </div>

        <div className="mt-6">
          <Button variant="outline" onClick={onClose} fullWidth>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactModal;